import { render, staticRenderFns } from "./CustomerAccount.vue?vue&type=template&id=fa8a3296&scoped=true&"
import script from "./CustomerAccount.vue?vue&type=script&lang=js&"
export * from "./CustomerAccount.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAccount.vue?vue&type=style&index=0&id=fa8a3296&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8a3296",
  null
  
)

export default component.exports